import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-screen-inner-loading',
  templateUrl: './screen-inner-loading.component.html',
  styleUrls: ['./screen-inner-loading.component.scss'],
})
export class ScreenInnerLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
